var webVersion = process.env.VUE_APP_VERSION;
var bucketId = "vision-service-static";
var regionType = "us-east-1";
var identityId = "us-east-1:707e0974-517d-4be3-a050-a875b2b1e014";
var baseUrl = "https://face.letstests.com";

if (process.env.NODE_ENV === "development") {} else if (process.env.NODE_ENV === "production") {
  //正式环境下才转正式服：
  //staging模式下还是指向测试服
  baseUrl = process.env.VUE_APP_FACE_BASE_URL;
}

export var CDN_BASE_URL = {
  img: "https://cdn.suprestart.com/img",
  remoteImg: "https://cdn.suprestart.com/assets/",
  js: "https://cdn.suprestart.com/js",
  css: "https://cdn.suprestart.com/css",
  video: "https://cdn.suprestart.com/video/online_files"
};
export { baseUrl, webVersion, bucketId, regionType, identityId };